import React, { useEffect, useState } from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import ibsStore from '../../Stores/IbsSurveyStore'


const DCSurveyInfoModal = observer(() => {
    let [showModal, showModalState] = useState(true);
    
    useEffect(() => {
        true
    }, [showModal])

    const closeModal = () => {

        showModalState(false)
    }


    let modalContent = null;

    modalContent = <React.Fragment>
        <div className="helpModal">
            <h3><i className="fa fa-exclamation-circle"></i> Please note
                    <span onClick={closeModal} className="close-button topright">&times;</span>
            </h3>

            <hr />
            <span>Parts of the survey have been pre-populated based on your responses last year. Review all the questions and update where the information has changed.</span><br /><br />
            <div className="center-div">
                <a onClick={closeModal} className="btn btn-info2" role="button">OK</a>
            </div>
        </div>

    </React.Fragment>;
    return (

        <React.Fragment>
            {
                ibsStore.currentSurvey?.NumChanges ==0 && ibsStore.sessionChanges==0 &&
                <section>

                    <Modal
                        visible={showModal}
                        width="800"
                        height="250"
                        effect="fadeInDown"
                        onClickAway={closeModal}
                    >
                        {modalContent}
                    </Modal>
                </section>
            }

        </React.Fragment>


    );

});

export default DCSurveyInfoModal;
